import ReactDOM from 'react-dom/client';
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { StrictMode } from 'react';
import { RouterProvider } from 'react-router-dom';
import { handleErrors } from './utils/errors.ts';
import { createRouter } from './routes.tsx';
import { isMissingBigQueryTableError } from './utils/error-utils.ts';
import CircularProgress from '@mui/material/CircularProgress';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnMount: true,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 1,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      if (query?.meta?.errorMessage && !isMissingBigQueryTableError(error)) {
        handleErrors({
          error,
          snackbarMessage: query.meta.errorMessage as string,
        });
      }
    },
  }),
});

const router = createRouter(queryClient);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider
        future={{ v7_startTransition: true }}
        router={router}
        fallbackElement={
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100vh',
            }}
          >
            <CircularProgress sx={{ color: '#6FC6AC' }} />
          </div>
        }
      />
    </QueryClientProvider>
  </StrictMode>
);
